import { ReportForm } from './ReportForm';
import { useLocalization } from '@ais-ui/locale-management';
import { UseFormReturn } from 'react-hook-form';
import { ReportsFormValues } from './useReportsForm';

interface SettingsReportsPageProps {
  form: UseFormReturn<ReportsFormValues>;
}

export function SettingsReportsPage({ form }: SettingsReportsPageProps) {
  const { messages } = useLocalization();

  return (
    <div className="space-y-6 w-full">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">
          {messages.settingsReportsListTitle}
        </h3>
      </div>
      <ReportForm form={form} />
    </div>
  );
}
